import * as yup from 'yup';
import { cpfValidator } from '../utils/validators';

export const schema = yup.object().shape({
    nome_completo: yup.string().required().min(3).max(150).trim(),
    cpf: yup
        .string()
        .required()
        .test('cpf-valido', 'CPF inválido', (v) => cpfValidator(v ?? '')),
    data_nascimento: yup.string().required(),
    telefone: yup
        .string()
        .required()
        .test('tel-11', 'Telefone deve ter 11 dígitos com DDD', (v) => {
            const d = (v ?? '').replace(/\D/g, '');
            return d.length === 11;
        }),
    estado: yup.string().required(),
    cidade: yup.string().required(),
    alfabetizado: yup.string().optional(),
    mobilidade_reduzida: yup.string().optional(),
    sexo: yup.string().optional(),
    nacionalidade: yup.string().optional(),
    legado: yup.string().optional(),
    tempo_admissao: yup
        .number()
        .nullable()
        .transform((v, o) => (String(o).trim() === '' ? null : v))
        .optional(),
    data_admissao: yup
        .string()
        .nullable()
        .test('admissao-single', 'Preencha apenas uma das opções de tempo de vínculo', function (value) {
            const { tempo_admissao } = this.parent;
            const hasTempo = tempo_admissao != null && String(tempo_admissao).trim() !== '';
            const hasData = !!value?.trim();
            return !(hasTempo && hasData);
        }),
    data_inicio_cnpj: yup.string().nullable().optional(),
    quantidade_funcionarios: yup
        .number()
        .nullable()
        .min(0)
        .transform((v, o) => (String(o).trim() === '' ? null : v))
        .optional(),
    tipo_produto: yup.string().nullable().optional(),
    parcela_minima: yup
        .number()
        .nullable()
        .min(0)
        .transform((v, o) => (String(o).trim() === '' ? null : v))
        .optional(),
});
